import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "flex" };
import { InfoCircleIcon } from '@gohighlevel/ghl-icons/24/outline';
import { UITextSmMedium, UITooltip } from '@gohighlevel/ghl-ui';
import { useCurrencyFormatter } from '@/composition/useCurrencyFormatter';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Amount',
    props: {
        amount: {
            type: Number,
            required: true,
        },
        currency: {
            type: String,
            required: true,
        },
        liveMode: {
            type: Boolean,
            required: true,
        },
    },
    setup(__props) {
        const { formatCurrencyValue } = useCurrencyFormatter();
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_unref(UITextSmMedium), { class: "text-gray-900" }, {
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(formatCurrencyValue)(__props.amount, __props.currency)), 1)
                    ]),
                    _: 1
                }),
                (!__props.liveMode)
                    ? (_openBlock(), _createBlock(_unref(UITooltip), { key: 0 }, {
                        trigger: _withCtx(() => [
                            _createVNode(_unref(InfoCircleIcon), { class: "text-gray-900 ml-1 mt-0.5 h-4 w-4" })
                        ]),
                        default: _withCtx(() => [
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('common.testMode')), 1)
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
